import React, { useState } from "react";
import { IconButton, Badge, Tooltip } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import NewReleasesIcon from "@material-ui/icons/NewReleases";
import ChangelogModal from "./ChangelogModal";
import { useChangelog } from "../../context/Changelog/ChangelogContext";

const ChangelogBadgeButton = ({ color = "inherit" }) => {
  const { unreadCount, roadmapDirty } = useChangelog();
  const [open, setOpen] = useState(false);
  const theme = useTheme();

  // Cor do ícone seguindo padrão dos demais ícones da AppBar:
  // - Tema claro: branco para contraste sobre a barra primária
  // - Tema escuro: usa a cor de texto primária do tema para manter consistência
  const iconColor = theme.mode === "light" ? "#fff" : theme.palette.text.primary;

  return (
    <>
      <Tooltip title="Novidades & Roadmap">
        <IconButton color={color} onClick={() => setOpen(true)} size="small" aria-label="Abrir novidades e roadmap">
          {(() => {
            const count = Number(unreadCount) || 0;
            const showNumber = count > 0;
            const showRoadmapOnly = !showNumber && !!roadmapDirty;

            if (!showNumber && !showRoadmapOnly) {
              return <NewReleasesIcon style={{ color: iconColor }} />;
            }

            const badgeContent = showNumber
              ? (count > 99 ? "99+" : count)
              : "•"; // Roadmap ativo sem novidades: usa bullet para manter o mesmo estilo "padrão"

            return (
              <Badge
                color="secondary"
                overlap="circle"
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                variant="standard"
                badgeContent={badgeContent}
              >
                <NewReleasesIcon style={{ color: iconColor }} />
              </Badge>
            );
          })()}
        </IconButton>
      </Tooltip>
      {open && <ChangelogModal open={open} onClose={() => setOpen(false)} />}
    </>
  );
};

export default ChangelogBadgeButton;
